module.exports = __webpack_public_path__ + "static/media/megan-fox-lose.c70cfbbb.jpg";